export const UPDATE_COUNTIES = 'UPDATE_COUNTIES';
export const UPDATE_COUNTIES_CODE = 'UPDATE_COUNTIES_CODE'
export const UPDATE_COUNTY_VALUES = 'UPDATE_COUNTY_VALUES'
export const VERIFY_CODE_TYPE = 'VERIFY_CODE_TYPE'
